import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled/macro';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { withTheme } from '../../Parameters/Deposit/List/DepositList';
import FormGroupCard from '../../../components/FormGroupCard/FormGroupCard';
import Button from '../../../components/Core/Button/Button';
import useBuildForm from '../../../hook/useBuildForm';
import { selectCollAndDeliveryPointID } from '../../../auth/selectors/authSelectors';
import { ParametersWaitingListType } from '../../../parameters/types/collectivity';
import { useSnackbar } from '../../../context/SnackbarContext';
import { TOAST_SEVERITY } from '../../../components/Core/Toast/Toast';
import updateWaitingListParametersForm from './updateWaitingListParametersForm';
import useWaitingListParametersApi from './useWaitingListParametersApi';

function WaitingListParametersPage() {
  const { t } = useTranslation(['admin/waitingListParameters', 'form']);
  const snackbar = useSnackbar();
  const { fetchWaitingListParameters, putWaitingListParameters } = useWaitingListParametersApi();
  const { id_coll } = useSelector(selectCollAndDeliveryPointID);
  const [waitingListParameters, setWaitingListParameters] = useState<ParametersWaitingListType | undefined>(undefined);
  const { builtFormFields, handleSubmit } = useBuildForm({
    formObject: updateWaitingListParametersForm(t),
    colsNumber: 3,
    defaultValues: waitingListParameters,
  });

  const onMount = useCallback(async () => {
    const response = await fetchWaitingListParameters({ id_coll });
    setWaitingListParameters(response?.data);
  }, [id_coll]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  const onSubmit = useCallback(
    handleSubmit(async (data) => {
      const response = await putWaitingListParameters({ ...data, id_coll });

      if (response?.status === 200) {
        snackbar?.setAlert({ message: t('form:global_update_success_message'), severity: TOAST_SEVERITY.success });
      }
    }),
    [id_coll]
  );

  return (
    <MainSection>
      <FormGroupCard
        title={null}
        WrapperComponent={({ children }) => <form onSubmit={onSubmit}>{children}</form>}
        FooterSlotComponent={({ defaultWrapper: DefaultWrapper }) => (
          <DefaultWrapper>
            <Button type={'submit'} label={t('form:global_update_label')} />
          </DefaultWrapper>
        )}>
        {builtFormFields}
      </FormGroupCard>
    </MainSection>
  );
}

const MainSection = styled.section`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default withTheme(WaitingListParametersPage);
